




























import { Vue, Component, Prop } from 'vue-property-decorator'
import type { VersaoDaTela } from '@/shareds/versao-da-tela'

/**
 * Troca entre a versão clássica e a nova de uma tela, no padrão do "Dashboard clássico" do Início: botão de texto
 * branco translúcido na barra roxa, igual nas duas versões, mudando só o que abre. A barra o desenha pelo registro
 * de shareds/troca-de-tela.
 */
@Component
export default class BotaoDeTrocaDeTela extends Vue {
	@Prop({ type: String, required: true }) destino!: VersaoDaTela
	@Prop({ type: String, default: '' }) assunto!: string
	@Prop({ type: Boolean, default: false }) carregando!: boolean
	@Prop({ type: Boolean, default: false }) destacar!: boolean

	get icone() {
		return this.destino === 'nova' ? 'mdi-creation' : 'mdi-history'
	}

	get texto() {
		return this.destino === 'nova' ? 'Nova tela' : 'Tela clássica'
	}

	// Tooltip do Vuetify e não title: o title não aparece para quem chega ao botão pelo teclado
	get dica() {
		const tela = this.destino === 'nova' ? 'nova tela' : 'tela clássica'
		return this.assunto ? `Abrir a ${tela} ${this.assunto}` : `Abrir a ${tela}`
	}

	// No celular a barra não tem espaço para o rótulo
	get compacto() {
		return this.$vuetify.breakpoint.xsOnly
	}
}
